/**
 * Forces the login drawer onto one screen so each state can be styled without walking the flow.
 * Pair it with `?modal=account`, which `helpers/modal-handler.js` already uses to open the drawer:
 *
 *   ?modal=account&flow=verify              verify-code screen
 *   ?modal=account&flow=verify&as=+61400000000
 *   ?modal=account&flow=details             the join form an unrecognised identifier leads to
 *   ?modal=account&flow=success             magic-link-sent screen
 *
 * Nothing is faked beyond the seed values: these are the real component states, and anything
 * submitted from them still goes to Omneo. Returns null when there is no `flow` param, which is
 * every real visit - so deleting this file plus its one call site removes the feature entirely.
 *
 * @param {Record<string, string>} states The flow's ACCOUNT_SIGN_IN_STATES, passed in to keep
 *   the state names in one place.
 * @param {string} [search]
 * @returns {{state: string, customer: object, identity: object} | null}
 */
export const resolveFlowPreview = (states, search = window.location.search) => {
  const params = new URLSearchParams(search)
  const flow = params.get('flow')
  if (!flow) return null

  const as = params.get('as')

  switch (flow) {
    case 'verify':
      return {
        state: states.MOBILE_CODE,
        customer: {},
        identity: { channel: 'mobile', value: as || '412345678', formatted: as || '+61412345678' }
      }
    case 'details':
      return {
        state: states.DETAILS,
        customer: { email: as || 'newcomer@example.com' },
        identity: { channel: 'email', value: as || 'newcomer@example.com', formatted: as || 'newcomer@example.com' }
      }
    case 'success':
      return {
        state: states.SUCCESS,
        /* An obviously fake barcode: JsBarcode needs a value or the card renders blank. */
        customer: { id: '0000000000', name: 'Sam Member' },
        identity: { channel: 'email', value: as || 'member@example.com', formatted: as || 'member@example.com' }
      }
    default:
      return null
  }
}
